function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { Constants } from '@shared/utils/constants';
import { get, AuthenticationTypes } from '@shared/services/http/httpProtocol';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: AuthenticationTypes.Spza,
    setBearerHeader: true,
    timeout: 120000
};
export const ReviewsQueryStrings = {
    OfferId: 'offer_id',
    ApiVersion: 'api-version',
    Source: 'source',
    UserId: 'user_id',
    From: 'from'
};
export function getReviewsByOfferId({ offerId, reviewsAPI, reviewsAPIVersion, correlationId, requestId, userId }) {
    const req = get(`${reviewsAPI}`, commonHttpOptions);
    if (userId) {
        req.addQueryEntry(ReviewsQueryStrings.UserId, userId);
    }
    return req.addQueryEntry(ReviewsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewsQueryStrings.OfferId, offerId).setHeader(Constants.Headers.RequestId, requestId).setHeader(Constants.Headers.CorrelationId, correlationId).request();
}
export function getUserReviewByOfferId({ token, offerId, source, correlationId, requestId, reviewsAPI, reviewsAPIVersion }) {
    const req = get(`${reviewsAPI}/private/user`, commonHttpOptions);
    req.setQuery({
        source
    });
    return req.addQueryEntry(ReviewsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewsQueryStrings.OfferId, offerId).setHeader(Constants.Headers.RequestId, requestId).setHeader(Constants.Headers.CorrelationId, correlationId).setAuthHeader(token).request();
}
export function getReviewsMetadata(_) {
    return _getReviewsMetadata.apply(this, arguments);
}
function _getReviewsMetadata() {
    _getReviewsMetadata = _async_to_generator(function*({ reviewsAPI, reviewsAPIVersion, legacyId }) {
        return yield get(`${reviewsAPI}/private/metadata`, commonHttpOptions).addQueryEntry(ReviewsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewsQueryStrings.OfferId, legacyId).request();
    });
    return _getReviewsMetadata.apply(this, arguments);
}
/**
 * @deprecated - This API is deprecated and should not be used, this is currently in use in order to retain legacy behaviour.
 */ export function getAllReviewsByTimestamp(_) {
    return _getAllReviewsByTimestamp.apply(this, arguments);
}
function _getAllReviewsByTimestamp() {
    _getAllReviewsByTimestamp = _async_to_generator(function*({ reviewsAPI, reviewsAPIVersion, timestamp, correlationId, requestId, source }) {
        return get(`${reviewsAPI}/deprecated`, commonHttpOptions).setQuery({
            source
        }).setHeader(Constants.Headers.RequestId, requestId).setHeader(Constants.Headers.CorrelationId, correlationId).addQueryEntry(ReviewsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewsQueryStrings.From, new Date(timestamp * 1000).toJSON()).request();
    });
    return _getAllReviewsByTimestamp.apply(this, arguments);
}
